/* @flow */
import liferay from '../../services/api';

import type { Action, AsyncAction } from '../../types';

const onFailure = (error: Object) => console.warn(error);

const fetchMedia = (id: number): AsyncAction => {
  return {
    type: 'FETCH_MEDIA_REQUEST',
    payload: id,
    promise: liferay.medias.get(id),
    meta: { onFailure },
  };
};

const mediaSetPageScroll = (pageScroll: number): Action => {
  return {
    type: 'MEDIA_SCROLL_PAGE',
    payload: pageScroll,
  };
};

const mediaExpandTrack = (trackId: number, isExpanded: boolean): Action => {
  return {
    type: 'MEDIA_EXPAND_TRACK',
    payload: {
      trackId,
      isExpanded,
    },
  };
};

const mediaToggleSelectTracks = (trackIds: number[]): Action => {
  return {
    type: 'MEDIA_TOGGLE_SELECT_TRACKS',
    payload: trackIds,
  };
};

const mediaToggleExpandSelectedTracks = (): Action => {
  return {
    type: 'MEDIA_TOGGLE_EXPAND_SELECTED_TRACKS',
  };
};

export default {
  mediaSetPageScroll,
  mediaExpandTrack,
  mediaToggleSelectTracks,
  mediaToggleExpandSelectedTracks,
  fetchMedia,
};
